import * as React from "react"
import {Box} from "@mui/material";

import {isLoadingCommonFilters} from "@signals";
import {marketPositionCurrentData} from "../@signals";


const LegendBlock = ({ label, value }) => <Box>
	<Box component="strong" sx={{ pr: .5 }}>
		{label}
	</Box>
	{value}
</Box>

export default function MarketplacesMarketPositionTooltip() {
	if (!marketPositionCurrentData.value.length && !isLoadingCommonFilters.value) return <></>

	return <Box sx={{ p: 1 }}>
		<Box sx={{ fontSize: 18, fontWeight: 'bold' }}>
			<Box component="span">
				{'{label}'}
			</Box>
		</Box>
		<LegendBlock label="Nº Products:" value='{value.formatNumber("#,###")}' />
		<LegendBlock label="Nº Sellers :" value='{valueY.formatNumber("#,###")}' />
		<LegendBlock label="Price dispersion vs RRSP:" value={'{valueX.formatNumber("#.##\'%\'")}'} />
	</Box>
}